<template>
  <div class="esign-multi-version">
    <EsignMultiVersion :applyTrial="true" :useCache="false" :env="env"></EsignMultiVersion>
  </div>
</template>

<script>
import { EsignMultiVersion } from '@esign-saas-component/esign-design-saas'
import Vue from 'vue'
import { MessageBox } from 'element-ui'
Vue.prototype.$confirm = MessageBox.confirm

export default {
  components: { EsignMultiVersion },
  computed: {
    env() {
      return process.env.VUE_APP_MODE
    },
  },
}
</script>

<style lang="less">
.esign-multi-version {
  .vip-body-col {
    img {
      width: 20px;
    }
  }
}
</style>
